
export default {
    name: "ContentBlockItem",
    components: {
        Section1: () => import("@/components/job/jobpage/sections/Section1"),
        Section2: () => import("@/components/job/jobpage/sections/Section2"),
        Section3: () => import("@/components/job/jobpage/sections/Section3"),
        Section4: () => import("@/components/job/jobpage/sections/Section4"),
    },
    model: {
        prop: "data",
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    computed: {
        headline() {
            return this.data.headline
        },
        text() {
            return this.data.text
        },
        media() {
            if (this.data.media) return this.data.media
            const videos = this.data.videos ?? []
            const images = this.data.images ?? []
            return videos.concat(images)
        },
        config() {
            return this.data.config ?? null
        },
        sectionComponent() {
            return `Section${((this.config?.id - 1) % 4) + 1}`
        },
    },
}
